<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading :module-id="access.module_id" :profile-id="access.profile_id" :reference="access.view_reference" summary-only />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-button variant="link" class="list-view-icon-btn list-view-icon-btn--primary" v-b-tooltip.hover.bottom
                        title="Agregar Reporte" aria-label="Agregar Reporte" @click="add()">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 150px;"><label class="filter-label">Desde</label><b-form-input type="date" size="sm" v-model="filter.date_start" /></div>
            <div class="list-view-filter" style="width: 150px;"><label class="filter-label">Hasta</label><b-form-input type="date" size="sm" v-model="filter.date_end" /></div>
            <div class="list-view-filter" style="flex: 1 1 180px; max-width: 260px;"><label class="filter-label">Clientes</label><v-select :options="arr.filter.customers" v-model="filter.customers" placeholder="Todos" :multiple="false" :select-on-tab="true" /></div>
            <b-button variant="outline-dark" size="sm" @click="filterReport()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;"><AppIcon name="filter" /></b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-card>
        <b-table class="app-table report-news-seller-table"
                ref="table"
                responsive
                :stacked="isMobileViewport ? 'md' : false"
                sticky-header="60vh"
                hover
                small
                :items="table.items"
                :fields="table.fields"
                :current-page="table.currentPage"
                :per-page="table.perPage"
                :busy="table.isBusy"
                v-if="table.items.length || table.isBusy">

          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Cargando...</strong>
            </div>
          </template>

          <template v-slot:cell(id)="data">
            <b>{{ data.item.id }}</b>
          </template>

          <template v-slot:cell(date)="data">
            {{ moment(data.item.date).format('DD MMMM YYYY') }}
          </template>

          <template v-slot:cell(customers)="data">
            <div v-if="data.item.customers_id">
              <b-avatar v-if="data.item.customer.image" :src="data.item.customer.image" size="25px" />
              <b-avatar v-else size="25px" :text="avatarFromName(data.item.customer.name).text" :style="avatarFromName(data.item.customer.name).style" />
              <strong class="ml-2">{{data.item.customer.name}}</strong>
              <AppIcon name="circle-fill" fill v-if="!data.item.customer.active" class="ml-2 text-danger" v-b-tooltip.hover title="Cliente inactivo" />
            </div>
          </template>

          <template v-slot:cell(observations)="data">
            <div v-if="data.item.observations" class="text-truncate" v-b-tooltip.hover :title="data.item.observations">{{data.item.observations}}</div>
          </template>

          <template v-slot:cell(f_action)="data">
            <b-dropdown right no-caret size="sm" variant="link" boundary="window"
                        :toggle-class="isMobileViewport ? 'report-news-seller-action-toggle-labeled' : 'app-table-action-toggle'"
                        :class="{ 'pull-right': !isMobileViewport }">
              <template #button-content><AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" /><span v-if="isMobileViewport">Opciones</span></template>
              <b-dropdown-item @click="irDetail(data.item)"><AppIcon name="visibility" /> Detalle</b-dropdown-item>
              <b-dropdown-item @click="sendPrinterOrder(data.item)"><AppIcon name="print" /> Imprimir</b-dropdown-item>
              <b-dropdown-header>Acciones</b-dropdown-header>
              <b-dropdown-item @click="edit(data.item)" v-if="access.elements.editReport">
                <AppIcon name="edit" /> Editar
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <EmptyState v-else icon="chat" title="No se encontraron novedades" description="Ajustá los filtros para ampliar la búsqueda." />

        <div class="app-table-footer">
          <span class="list-view-toolbar__count" v-if="table.tablePaginate">{{ table.tablePaginate.total }} registros</span>
          <export-excel class="list-view-link" :data="arr.export" worksheet="Informe de Novedades" name="reports-news-seller.xls">
            <AppIcon name="download" class="mr-1" /> Exportar
          </export-excel>
        </div>
      </b-card>

      <b-card body-class="py-2">
        <section class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)"><AppIcon name="arrow_back" class="mr-1" /> Volver</b-button>
          <b-pagination v-if="table.tablePaginate" class="mb-0"
                        size="sm"
                        pills
                        :total-rows="table.tablePaginate.total"
                        :per-page="table.tablePaginate.per_page"
                        v-model="table.currentPage"
                        @input="filterReport()" />
        </section>
      </b-card>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.id"
              :reference="crud.print.reference"
              :registerID="crud.print.id"
              :key="crud.print.key"/>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              no-close-on-esc
              no-close-on-backdrop
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Fecha">
              <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <FindObject render="search"
                        type="customers-by-seller"
                        :extra-filter-data="{ sellers_id: sellerID }"
                        @select-object="loadCustomers($event)"
                        :valueID="crud.form.customers_id"/>
          </b-col>

          <b-col md="12">
            <b-form-group label="Observaciones">
              <app-textarea
                v-model="crud.form.observations"
                placeholder="Ingresar las observaciones..."
                rows="3"
                max-rows="6"
              ></app-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Funciones from '@/handler/funciones'
  import moment from 'moment'
  import FindObject from '@/components/inc/find/findObject'
  import Vue from 'vue'
  import excel from 'vue-excel-export'
  import Storage from '@/handler/storageSession'
  import StorageLocal from '@/handler/storageLocal'
  import Printer from '@/components/inc/printer/printer'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  Vue.use(excel)

  export default {
    components: {
      FindObject,
      Printer,
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.INFORME_NOVEDADES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudReportSeller',
          elements: {
            editReport: true,
          }
        },
        table : {
          items: [],
          fields: [],
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,
        },
        filtersOpen: false,
        isMobileViewport: false,
        mobileMql: null,
        crud: {
          form: {
            id: 0,
            date: '',
            observations: '',
            staff_id: 0,
            sellers_id: 0,
            customers_id: 0,
            customers: null,
            read: false,
          },
          print: {
            reference: 'reports-news',
            id: 0,
            key: 0,
          }
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        },
        arr: {
          export: [],
          filter : {
            customers: [],
          },
        },
        filter: {
          date_start: '',
          date_end: '',
          customers: null,
          staff: [],
          sellers: [],
        },
        customersID: 0,
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.editReport = Helper.hasAccessElement(this.access, 'edit_report')
      /* Fin configuracion */
    },
    mounted() {
      this.customersID = this.$route.params.customersID
      if(this.customersID) {
        this.validCustomers()
      }

      this.filterLoad()
      this.filtersOpen = StorageLocal.getValue('filters_open_crud_report_seller_news') === 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadFieldTable()
      this.filterReport()
    },
    beforeDestroy() {
      if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    watch: {
      filtersOpen(value) { StorageLocal.setValue('filters_open_crud_report_seller_news', value ? 'true' : 'false') },
      isMobileViewport() { this.loadFieldTable() },
    },
    computed: {
      sellerID() { return Helper.getSeller().id },
    },
    methods: {
      updateMobileViewport(event) { this.isMobileViewport = event.matches },
      alignClass(desktopClass) { return this.isMobileViewport ? 'text-left' : desktopClass },
      avatarFromName(name) { return Funciones.avatarFromName(name) },
      loadFieldTable() {
        this.table.fields = [
          {key: 'id', label: 'ID', sortable: true, class: 'align-middle ' + this.alignClass('text-center'), width: '60px'},
          {key: 'date', label: 'Fecha', class: 'align-middle ' + this.alignClass('text-left'), width: '130px'},
          {key: 'customers', label: 'Cliente', class: 'align-middle ' + this.alignClass('text-left')},
          {key: 'observations', label: 'Observaciones', class: 'align-middle text-wrap ' + this.alignClass('text-left')},
          {key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: 'align-middle ' + this.alignClass('text-right'), width: '50px'},
        ]
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      validCustomers() {
        this.add()
        this.crud.form.customers_id = this.customersID
      },
      loadCustomers(object) {
        if(object) {
          this.crud.form.customers = object
          this.crud.form.customers_id = object.id
        } else {
          this.crud.form.customers = null
          this.crud.form.customers_id = 0
        }
      },

      add() {
        this.crud.form.id = 0
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.observations = ''
        this.crud.form.staff_id = 0
        this.crud.form.sellers_id = Helper.getSeller().id
        this.crud.form.customers_id = 0
        this.crud.form.customers = null
        this.crud.form.read = false

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Reporte"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.date = item.date
        this.crud.form.observations = item.observations
        this.crud.form.staff_id = item.staff_id
        this.crud.form.sellers_id = item.sellers_id
        this.crud.form.customers_id = item.customers_id
        this.crud.form.customers = item.customer
        this.crud.form.read = item.read

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Reporte"
        this.modal.form.active = true
      },
      save() {
        this.confirmDialog('¿Desea continuar con la operación?', {
          title: 'Guardar Reporte',
          icon: 'save',
          okTitle: 'Aceptar',
          cancelTitle: 'Cancelar'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = this.crud.form.id ? serviceAPI.editar(this.crud.form) : serviceAPI.agregar(this.crud.form)

            result.then(() => {
              this.modal.form.active = false
              loader.hide()
              this.filterReport()
              this.$awn.success("Datos guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      filterLoad() {
        this.filterLoadCustomers()
        this.filter.date_start = moment().subtract(7, 'days').format('YYYY-MM-DD')
        this.filter.date_end = moment().format('YYYY-MM-DD')

        this.restoreFilterStorage()
      },
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientesByZonas({ sellers_id: Helper.getSeller().id })
        result.then((response) => {
          var data = response.data

          this.arr.filter.customers = []
          data.forEach(element => {
            if(element.code) {
              this.arr.filter.customers.push({ code: element.id, label: element.code + ' | ' + element.name })
            } else {
              this.arr.filter.customers.push({ code: element.id, label: element.name })
            }
          });
        })
      },
      filterReport(){
        this.table.isBusy = true

        this.filter.sellers = []
        this.filter.sellers.push({
          code: Helper.getSeller().id,
          label: Helper.getSeller().name,
        })

        if(! Array.isArray(this.filter.customers) && this.filter.customers != null) {
          this.filter.customers = [this.filter.customers]
        }

        var result = serviceAPI.filtrarReport(this.filter, this.table.currentPage)
        result.then((response) => {
          var data = response.data
          this.table.tablePaginate = data

          this.table.items = data.data
          this.prepareExport(data.data)

          if(this.$refs.table) {
            this.$refs.table.$forceUpdate()
          }

          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });
      },
      prepareExport(data) {
        this.arr.export = []
        data.forEach(element => {
          var customersID = 0
          var customersCode = ''
          var customersName = ''

          if(element.customers_id) {
            customersID = element.customer.id
            customersCode = element.customer.code
            customersName = element.customer.name
          }

          this.arr.export.push({
            id: element.id,
            date: element.date,
            customersID: customersID,
            customersCode: customersCode,
            customersName: customersName,
            observations: element.observations
          })
        });
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_report_seller_news', JSON.stringify(this.filter))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_report_seller_news')) {
          this.filter = JSON.parse(Storage.getValue('filter_report_seller_news'))
        }
      },

      irDetail(item){
        this.saveFilterStorage()
        this.$router.push({ name: 'ReportsNewsStaffDetailReport', params: {reportID: item.id} })
      },
      sendPrinterOrder(item) {
        this.crud.print.key=Math.random()
        this.crud.print.id=item.id
      }
    }
  }
</script>
<style>
  .btn.report-news-seller-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.report-news-seller-action-toggle-labeled:hover,
  .btn.report-news-seller-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .report-news-seller-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
    .report-news-seller-table.app-table.b-table-stacked-md > tbody > tr > td:last-child {
      text-align: left !important;
    }
  }
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;
  }
</style>
